import { TextInput } from '@pandiafi/design-system'
import { Field, FieldProps, setIn } from 'formik'
import { t } from 'i18next'
import React from 'react'

import FormFieldWrapper from 'components/FormField'
import { BeneficiaryType } from 'views/TerminateContract/TerminateForm/initialValues'
import { countryCodeFromIban } from 'views/TerminateContract/utils/bankCountry'

interface BeneficiaryIbanFieldProps {
  index: number
  required?: boolean
}

export const BeneficiaryIbanField: React.FC<BeneficiaryIbanFieldProps> = ({
  index,
  required,
}) => {
  return (
    <Field name={`beneficiaries[${index}]iban`}>
      {({ field, form, meta }: FieldProps<BeneficiaryType['iban']>) => (
        <FormFieldWrapper
          name={field.name}
          required={required}
          label={t('terminateContract:labels.iban')}
          className="min-tablet:flex-1"
          meta={meta}
          labelBold
        >
          <TextInput
            {...field}
            onChange={(event) => {
              const iban = event.currentTarget.value
              const ibanCountryCode = countryCodeFromIban(iban)

              if (ibanCountryCode === null) {
                field.onChange(event)
              } else {
                void form.setValues(
                  setIn(
                    setIn(form.values, field.name, iban),
                    `beneficiaries[${index}]bankCountryCode`,
                    ibanCountryCode
                  )
                )
              }
            }}
          />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
